import { useApiClient } from '@eluve/api-client-provider';
import { Stack, useToast } from '@eluve/components';
import {
  useAppointmentContext,
  useAppointmentStatus,
} from '@eluve/frontend-appointment-hooks';
import { SearchableDiagnoses } from '@eluve/frontend-feature-appointment';
import { AppointmentStatusTypesLookup } from '@eluve/graphql-types';
import { useTranslation } from '@eluve/i18n';
import { FeatureFlaggedComponent } from '@eluve/smart-blocks';

import { DifferentialDiagnosesComponent } from './DifferentialDiagnosesComponent';

export const DifferentialDiagnosesTabContent: React.FC = () => {
  const { t } = useTranslation();
  const toast = useToast();
  const { tenantId, appointmentId } = useAppointmentContext();
  const apiClient = useApiClient();
  const apptStatus = useAppointmentStatus();

  const onDiagnosesSelected = async (diagnosis: string) => {
    try {
      const result = await apiClient.llm.generateDiagnosisJustification({
        params: { tenantId, appointmentId },
        body: {
          targetDiagnosis: diagnosis,
        },
      });

      if (result.status === 422) {
        toast.error(result.body.message);
        return;
      }

      if (result.status !== 201) {
        toast.error(t('appointmentPage.insights.generateOutputFailed'));
        return;
      }
    } catch {
      toast.error(t('appointmentPage.insights.generateOutputFailed'));
    }
  };

  return (
    <Stack gap={3}>
      {apptStatus !== AppointmentStatusTypesLookup.COMPLETED && (
        <FeatureFlaggedComponent flag="USER_INPUT_DIFFERENTIAL_DIAGNOSIS">
          <SearchableDiagnoses
            onItemSelected={(dx) => onDiagnosesSelected(dx.name)}
          />
        </FeatureFlaggedComponent>
      )}
      <DifferentialDiagnosesComponent />
    </Stack>
  );
};
